document.addEventListener('change', (event) => {
  const variantContainer = event.target.closest('variant-selects');
  if (!variantContainer) return;

  setTimeout(() => {
    const urlParams = new URLSearchParams(window.location.search);
    let variantId = urlParams.get('variant');
    if (!variantId) {
      variantId = variantContainer.closest('product-info, .product-single, body')?.querySelector('input[name="id"]')?.value;
    }

    if (!variantId) return;

    // ==========================================
    // Backorder warning
    // ==========================================
      const wrapper = document.querySelector('.product-backorder-wrapper');
      if (!wrapper) return;

      const notice = wrapper.querySelector('.stock-warning');
      if (!notice) return;

      const productId = wrapper.getAttribute('data-product-id') || Object.keys(window.productBackorderData)[0];
      const productData = window.productBackorderData?.[productId];
      
      if (!productData) return;

      const isBackorder = productData[variantId] === true;

      if (isBackorder) {
        notice.classList.remove('hidden');
      } else {
        notice.classList.add('hidden');
      }

    // ==========================================
    // Group-price (With Parent Fallback)
    // ==========================================
    const priceWrapper = document.querySelector('.product-unit-price-wrapper');
    if (priceWrapper) {
      const productId = priceWrapper.getAttribute('data-product-id') || Object.keys(window.productPricingData)[0];
      const productData = window.productPricingData?.[productId];
      let variantData = productData?.[variantId];

      const priceElement = priceWrapper.querySelector('.dynamic-unit-price');

      const parentData = productData?.["parent"];
      
      const qty = variantData?.qty ? parseFloat(variantData.qty) : (parentData?.qty ? parseFloat(parentData.qty) : null);
      const unit = variantData?.unit ? variantData.unit : (parentData?.unit ? parentData.unit : null);
      
      let mult = 1;
      if (variantData?.mult) {
        mult = parseFloat(variantData.mult);
      } else if (parentData?.mult) {
        mult = parseFloat(parentData.mult);
      }

      const rawPrice = variantData?.price ? parseFloat(variantData.price) / 100 : null;

      if (rawPrice && qty && unit) {
        if (qty > 0) {
          let calculatedUnitPrice = rawPrice / qty;
          if (mult > 1) {
            calculatedUnitPrice = calculatedUnitPrice * mult;
          }

          const formattedPrice = new Intl.NumberFormat('de-DE', { 
            style: 'currency', 
            currency: 'EUR' 
          }).format(calculatedUnitPrice);

          priceElement.innerHTML = `(<b>${formattedPrice}</b> / ${mult > 1 ? mult : '1'}${unit})`;
          priceWrapper.style.display = 'block';
        } else {
          priceElement.innerHTML = '';
          priceWrapper.style.display = 'none';
        }
      } else {
        priceElement.innerHTML = '';
        priceWrapper.style.display = 'none';
      }
    }
    
  }, 600);
});